export default "__VITE_ASSET__RCQHFubK__"